module.exports = __webpack_public_path__ + "static/images/jf-spike-jjks.cd7df8c.png";